var klaviyo = klaviyo || [];
klaviyo.init({
  account: 'NFGJS3',
  list: 'Mf2fqA',
  platform: 'shopify',
  exclude_on_tags: 'status_dis'
});
klaviyo.enable("backinstock",{ 
  trigger: {
    product_page_text: "Email me when it's back",
    product_page_class: "button-klav",
    product_page_text_align: "center",
    product_page_margin: "0 0 0 0",
    replace_anchor: true
  },
  modal: {
    headline: "Email me when it's back",
    body_content: "Register to receive a notification as soon as this item becomes available.",
    email_field_label: "name@email.com",
    button_label: "Register",
    subscription_success_label: "Fantastic... we'll let you know when it's back.",
    footer_content: '',
    additional_styles: "",
    drop_background_color: "#000",
    background_color: "#fff",
    text_color: "#222",
    button_text_color: "#fff",
    button_background_color: "#fff",
    close_button_color: "rgba(0, 0, 0, 0.1)",
    error_background_color: "#fcd6d7",
    error_text_color: "#C72E2F",
    success_background_color: "#d3efcd",
    success_text_color: "#1B9500",
    newsletter_subscribe_label: "Add me to your email list.",
    subscribe_checked: true,
    font_family: "semplicitapro",
    headers_font_family: "semplicitapro"
  }
});
